<script setup lang="ts">
import { Tooltip } from "@/components/ui/tooltip";

defineProps<{
  baseLabel?: string | null;
  weighted?: boolean;
}>();
</script>

<template>
  <span
    v-if="baseLabel || weighted"
    class="inline-flex items-center whitespace-pre">
    <span>(</span>
    <Tooltip
      v-if="baseLabel"
      :content="`Results are computed on a custom base: ${baseLabel}`">
      <span>Base: {{ baseLabel }}</span>
    </Tooltip>
    <span v-if="baseLabel && weighted"> · </span>
    <Tooltip
      v-if="weighted"
      content="A weighting is applied to these results">
      <span>Weighted</span>
    </Tooltip>
    <span>)</span>
  </span>
</template>
